document.addEventListener("DOMContentLoaded", () => {
  var $ProInfo = $(".ann-pro-container");
  var $ProItem = $(".ann-pro-item");
  var $NavItem = $('.ann-pro-nav-item')

  $ProItem.click(function () {
    var $this = $(this);
    if (!$this.hasClass("active")) {
      $ProItem.removeClass("active");
      $this.addClass("active");

      var index = $this.attr("index");
      $ProInfo.removeClass("active").filter(`[index="${index}"]`).addClass("active");
      $NavItem.removeClass("active").filter(`[index="${index}"]`).addClass("active");
    }
  });



  var $NotifyBtn = $('.ann-pro-btn')

  $NotifyBtn.click(function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VbvBm9']);
  })

});
